import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { Select } from 'components/fields'
import { Button, FormData, Module } from 'components/misc'
import { apiContacts } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { availableContactsDropdownSelector, contactsDropdownSelector } from 'redux/selectors/contacts'

@apiContacts({
  disableLimit: true,
  onlyActive: true
})
@form({
  form: 'add-authorising-contact'
})
@connect(state => ({
  dropdownOrganizationContacts: contactsDropdownSelector(state)
}))
class AuthorisingContact extends Component {
  static propTypes = {
    data: PropTypes.object,
    modal: PropTypes.func.isRequired,
    fetchOrganizationContacts: PropTypes.func,
    handleSubmit: PropTypes.func,
    onContactChange: PropTypes.func.isRequired,
    dropdownOrganizationContacts: PropTypes.array.isRequired,
    organizationId: PropTypes.number,
    grid: PropTypes.bool
  }

  static defaultProps = {
    data: {},
    dropdownOrganizationContacts: [],
    grid: true
  }

  key = uuid.v1()

  handleModalDisplay = () => {
    this.props.modal(`modal-contact-change-${this.key}`)
    this.props.fetchOrganizationContacts()
  }

  render () {
    const {
      data,
      dropdownOrganizationContacts,
      handleSubmit,
      organizationId,
      grid
    } = this.props

    const availableOrganizationContacts = availableContactsDropdownSelector(
      dropdownOrganizationContacts,
      data
    )

    const buttonDefinition = [
      {
        'order': 1,
        'secondary': true,
        'onClick': this.handleModalDisplay,
        'iconAction': null,
        'isActionLoading': false,
        'intlKeyAction': 'button.change',
        'action': 'Change'
      }
    ]

    return (
      <div>
        <Module
          title={'Authorising contact'}
          intlKey={'moduleTitle.authorising_contact'}
          primary
          grid={grid}
          buttonDefinition={buttonDefinition}
        >
          <div className="row">
            <div className="col-xs-4">
              <FormData label="First Name" intlKey="label.first_name">
                {get(data, 'firstName') ||
                  get(data, 'person.firstName') ||
                  '---'}
              </FormData>
            </div>
            <div className="col-xs-4">
              <FormData label="Middle Name" intlKey="label.middle_name">
                {get(data, 'middleName') ||
                  get(data, 'person.middleName') ||
                  '---'}
              </FormData>
            </div>
            <div className="col-xs-4">
              <FormData label="Last Name" intlKey="label.last_name">
                {get(data, 'lastName') || get(data, 'person.lastName') || '---'}
              </FormData>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-4">
              <FormData label="Email" intlKey="label.email">
                {get(data, 'email') || get(data, 'person.email') || '---'}
              </FormData>
            </div>
            <div className="col-xs-4">
              <FormData label="Phone" intlKey="label.phone">
                {get(data, 'phone') || get(data, 'person.phone') || '---'}
              </FormData>
            </div>
          </div>
        </Module>
        <Modal
          id={`modal-contact-change-${this.key}`}
          customActions
          enableOverflow
        >
          <form
            onSubmit={handleSubmit(fields =>
              this.props.onContactChange(organizationId, fields)
            )}
          >
            <Select
              label="Organization contact"
              name="contactId"
              intlKey="label.organization_contact"
              options={availableOrganizationContacts}
              searchable
            />
            <div className="row">
              <div className="col-xs-6">
                <Button
                  type="button"
                  secondary
                  onClick={() => this.props.modal(null)}
                  intlKey="button.close"
                >
                  Close
                </Button>
              </div>
              <div className="col-xs-6 text--right">
                <Button intlKey="button.set">Set</Button>
              </div>
            </div>
          </form>
        </Modal>
      </div>
    )
  }
}

export default AuthorisingContact
